import React, { useLayoutEffect, useState, useEffect } from 'react'
import DataGrid, {
    Column,
    Export,
    HeaderFilter,
    Pager,
    Paging,
    SearchPanel,
} from "devextreme-react/data-grid";
import { useSelector } from "react-redux";
import Swal from 'sweetalert2';
import { Button, TextBox, CheckBox } from "devextreme-react";
import { useNavigate } from "react-router-dom";
import Popup from "devextreme-react/popup";
import { CategoryService } from '../../../apis/apiServices/Category'

export default function CategoryComponent() {
    useLayoutEffect(() => {
        document.querySelector("#pageTitle").innerHTML = "Category";
        getCategoryList();
    }, []);

    const [stateList, setCategoryList] = useState(null);
    const user = useSelector((state) => state.user.data);
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [iomCategoryModalOpen, setIOMCategoryModalOpen] = useState(false);
    const [category, setCategory] = useState({
        Id: 0,
        name: '',
        code: '',
    });


    const getCategoryList = async () => {
        try {
            const response = await CategoryService.getCategoryList()
            setCategoryList(response?.data);
        } catch (error) {
            console.log("Error getCategoryList===>", error);
        }
    }

    const handleSubmit = async () => {


        const newErrors = {};
        if (!category?.name) newErrors.name = "Please enter category name";
        if (!category?.code) newErrors.code = "Please enter category code";
        // if (!category?.UserIds.length) newErrors.UserIds = "Please select users";

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            //setIsSubmitted(false);
            return;
        }
        let body = {
            name: category?.name,
            code: category?.code,
            CreatedBy: user.userId,
        };
        const response = await CategoryService.addCategory(body);

        if (!response?.isSuccess) {
            Swal.fire(
                "",
                `${response?.message}`,
                "error"
            );
            return;
        }
        setIOMCategoryModalOpen(false)
        Swal.fire(
            "",
            `${response?.message}`,
            "success"
        ).then(() => { navigate(`/category`) });
    };


    const openModal = () => {
        // setIomApprover({
        //     designationId: 0,
        //     approvalConfigurationId: 0,
        //     UserIds: [],
        //     isActive: true,
        // });
        setIOMCategoryModalOpen(true);
    };

    const handleInputChange = (e, field) => {
        setCategory((prev) => ({
            ...prev,
            [field]: e.value
        }));
    };

    useEffect(() => {
        getCategoryList();
    }, [])
    return (
        <>
            <div className="content">
                <div className="card">
                    <div className="card-body">
                        <div class="tab-content" id="custom-tabs-tabContent">
                            <DataGrid
                                dataSource={stateList}
                                // columnAutoWidth={true}
                                showColumnLines={false}
                                showRowLines={true}
                                showBorders={true}
                                allowColumnResizing={false}
                                onToolbarPreparing={(e) => {
                                    e.toolbarOptions.items.unshift({
                                        location: "before",
                                        widget: "dxButton",
                                        //visible: (props?.isAllowedForThisRole || props?.featurePermission?.canAdd) ? true : false,
                                        options: {
                                            icon: "plus",
                                            text: "New",
                                            type: "default",
                                            stylingMode: "contained",
                                            onClick: () => openModal(),
                                            hint: "New",
                                        }
                                    });
                                }}
                            >
                                {/* <Column
                                    type="buttons"
                                    width={50}
                                    buttons={[
                                        {
                                            hint: "Edit Category",
                                            icon: "fas fa-edit text-link",
                                            onClick: (e) => {
                                                //debugger
                                                window.location.href = `/edit-category/${e.row?.data?.id}`;
                                            },
                                        },
                                        {
                                            hint: "View Category",
                                            icon: "fas fa-eye text-link",
                                            onClick: (e) => {
                                                //openViewVendorModal(e.row?.data?.id);
                                            },
                                        },
                                    ]}
                                /> */}
                                <Column dataField="name" caption="Name" />
                                <Column dataField="code" caption="Code" />
                                <HeaderFilter visible={false} />
                                <SearchPanel
                                    visible={true}
                                    highlightCaseSensitive={true}
                                    width={200}
                                    placeholder="Search..."
                                />
                                <Paging defaultPageSize={15} />
                                <Pager
                                    visible={true}
                                    allowedPageSizes={[10, 15, 20, 50, 100]}
                                    showPageSizeSelector={true}
                                    showInfo={true}
                                    showNavigationButtons={true}
                                />
                                <Export enabled={true} fileName="Category" />
                            </DataGrid>
                        </div>
                    </div>
                </div>
            </div>
            <Popup
                visible={iomCategoryModalOpen}
                onHiding={() => setIOMCategoryModalOpen(false)}
                dragEnabled={false}
                showTitle={true}
                title={category?.Id ? "Update Category" : "Add Category"}
                height="auto"
                weight="auto"
                className='custom-modal-popup'
            >
                <div className='popup-body'>
                    <div className="form-group">
                        <label>Name <span className="text-danger">*</span></label>
                        <TextBox
                            className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                            placeholder="Enter category name"
                            showClearButton={true}
                            valueChangeEvent="keyup"
                            value={category?.name}
                            onValueChanged={(e) => handleInputChange(e, "name")}
                        // maxLength={20}
                        />
                        {errors.name && (
                            <div className="error invalid-feedback">{errors.name}</div>
                        )}
                    </div>
                    <div className="form-group">
                        <label>Code <span className="text-danger">*</span></label>
                        <TextBox
                            className={`form-control ${errors.code ? 'is-invalid' : ''}`}
                            placeholder="Enter category code"
                            showClearButton={true}
                            valueChangeEvent="keyup"
                            value={category?.code}
                            onValueChanged={(e) => handleInputChange(e, "code")}
                        // maxLength={20}
                        />
                        {errors.code && (
                            <div className="error invalid-feedback">{errors.code}</div>
                        )}
                    </div>
                </div>
                <div className='text-right'>
                    <Button icon='close'
                        text="Cancel"
                        onClick={() => {
                            setIOMCategoryModalOpen(false);
                            setCategory("");
                            setErrors("");
                        }}
                        stylingMode="outlined"
                        className="btn btn-outline-primary btn-sm mr-2"
                    />
                    <Button
                        icon='check'
                        text="Submit"
                        type="success"
                        onClick={handleSubmit}
                        className="btn btn-primary btn-sm"
                    />
                </div>
            </Popup>
        </>
    )
}
